// extracted by mini-css-extract-plugin
export default {"dynamicTooltip":"DynamicTooltip_dynamicTooltip__Gzb8v","visible":"DynamicTooltip_visible__Wmm4N"};